export default "__VITE_ASSET__CmDetR5F__"